import { UserRole } from "@common/utils/graphql";
import { atom } from "recoil";

export const roleState = atom<UserRole>({
  key: "roleState", // unique ID (with respect to other atoms/selectors)
  default: UserRole.Employee,
});

export const availableRoles = atom<UserRole[]>({
  key: "availableRoles", // unique ID (with respect to other atoms/selectors)
  default: [UserRole.Employee],
});

export const hasRole = (role: UserRole, availableRoles: UserRole[]) => {
  return !!availableRoles.find((r) => r === role);
};

export const getHighestRole = (availableRoles: UserRole[]) => {
  if (hasRole(UserRole.Admin, availableRoles)) {
    return UserRole.Admin;
  } else if (hasRole(UserRole.Manager, availableRoles)) {
    return UserRole.Manager;
  }
  return UserRole.Employee;
};
